import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { ErrorAlert } from "./SuccessAlert";

const ProtectedRoutes = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  let localRole = localStorage.getItem("role");
  const checkAuthentication = () => {
    const token = localStorage.getItem("accessToken");

    if (!token || token.split(".").length !== 3) {
      console.warn("Invalid or missing JWT token");
      setIsAuthenticated(false);
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        setIsAuthenticated(false);
        ErrorAlert("Your session has expired. Please log in again.");
        if (localRole === "super_admin") {
          Navigate("/");
          localStorage.clear();
        } else if (localRole === "school_admin") {
          Navigate("/school-admin/login");
          localStorage.clear();
        } else if (localRole === "teacher") {
          Navigate("/teacher/login");
          localStorage.clear();
        } else {
          Navigate("/");
        }
      } else {
        setIsAuthenticated(true);
      }
    } catch (error) {
      console.error("Error decoding token:", error);
      setIsAuthenticated(false);
    }
  };

  useEffect(() => {
    checkAuthentication();
  }, []);

  // FIX: return a loading spinner, not 'undefined'
  if (isAuthenticated === null) {
    document.body.classList.add("loading-indicator");
    return <div className="flex justify-center py-20">Loading...</div>;
  }

  // Remove the loading class after ready
  document.body.classList.remove("loading-indicator");

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default ProtectedRoutes;
